import { Box, Grid, TextField, Typography } from '@material-ui/core'
import { useEffect, useState } from 'react'
import { Button } from 'react-admin'
import Api from '../../../Apis/api.service'
import useStyles from '../styles'
import { darkGrey } from '../utils'
import AlertMessage from './AlertMessage'

const PrestaInformationsEditForm = ({ record, setRefresh }) => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const [presta, setPresta] = useState({})
  const [open, setOpen] = useState(false)
  const [isError, setIsError] = useState(false)
  const [message, setMessage] = useState('')
  const [errors, setErrors] = useState([
    {
      source: 'invoice_adresse',
      error: false,
    },
    { source: 'invoice_cp', error: false },
    {
      source: 'invoice_ville',
      error: false,
    },
    {
      source: 'invoice_siret',
      error: false,
    },
    { source: 'invoice_tva', error: false },
    {
      source: 'invoice_iban',
      error: false,
    },
  ])

  const getInfosPresta = async (id) => {
    const res = await Api.prestas.getInfosPrestaByToken(id)
    if (res.status == 200) {
      setPresta(() => {
        return res.data
      })
    }
  }
  const onSuccess = () => {
    setIsError(false)
    setMessage("Merci, c'est bien enregistré !")
    setOpen(true)
  }
  const onFailure = (res) => {
    setIsError(true)
    setMessage('Une erreur est survenue , veuillez réessayez plus tard.')
    setOpen(true)
    console.log({ res })
  }
  const validate = () => {
    const errs = [
      {
        source: 'invoice_adresse',
        error: presta['invoice_adresse'] ? false : true,
      },
      { source: 'invoice_cp', error: presta['invoice_cp'] ? false : true },
      {
        source: 'invoice_ville',
        error: presta['invoice_ville'] ? false : true,
      },
      {
        source: 'invoice_siret',
        error: presta['invoice_siret'] ? false : true,
      },
      { source: 'invoice_tva', error: presta['invoice_tva'] ? false : true },
      {
        source: 'invoice_iban',
        error: presta['invoice_iban'] ? false : true,
      },
    ]
    setErrors(() => {
      return [...errs]
    })
    return errs
  }
  const onSubmit = async () => {
    setLoading(true)
    const valid = validate().filter((item) => item.error)
    if (valid.length) {
      setLoading(false)
      return
    }
    const res = await Api.prestas.updateInfosPresta(record.id, presta)
    if (res.status == 200) {
      onSuccess()
    } else {
      onFailure(res.data)
    }
    setLoading(false)
    setRefresh(() => {
      return new Date().getTime()
    })
  }
  useEffect(() => {
    getInfosPresta(record.id)
  }, [record])
  const handleChange = (e, source) => {
    setErrors(() => {
      return errors.map((item) => {
        const err = e.target.value ? false : true
        return item.source == source ? { ...item, error: err } : item
      })
    })
    setPresta({
      ...presta,
      [source]: e.target.value,
    })
  }
  return (
    <Grid container justify="center" className={classes.spacing}>
      <Grid item xs={11} md={6}>
        <Box className={classes.paperPrestaInfos}>
          <Box variant="outlined">
            <PrestaParagraph />
            <Grid
              container
              justifyContent="center"
              style={{
                rowGap: 10,
                columnGap: 10,
              }}
              xs={12}
            >
              <AlertMessage
                open={open}
                setOpen={setOpen}
                isError={isError}
                message={message}
                setMessage={setMessage}
              />
              <Grid item xs={12} sm={5}>
                <TextField
                  error={
                    errors.find((item) => item.source == 'invoice_adresse')
                      ?.error
                  }
                  InputLabelProps={{
                    shrink: true,
                    required: true,
                  }}
                  fullWidth
                  label="Adresse"
                  helperText={false}
                  value={presta['invoice_adresse']}
                  onChange={(e) => {
                    handleChange(e, 'invoice_adresse')
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={5}>
                <TextField
                  InputLabelProps={{
                    shrink: true,
                    required: true,
                  }}
                  fullWidth
                  value={presta['invoice_cp']}
                  error={
                    errors.find((item) => item.source == 'invoice_cp')?.error
                  }
                  onChange={(e) => {
                    handleChange(e, 'invoice_cp')
                  }}
                  label="Code Postal"
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12} sm={5}>
                <TextField
                  InputLabelProps={{
                    shrink: true,
                    required: true,
                  }}
                  fullWidth
                  value={presta['invoice_ville']}
                  error={
                    errors.find((item) => item.source == 'invoice_ville')?.error
                  }
                  onChange={(e) => {
                    handleChange(e, 'invoice_ville')
                  }}
                  label="Ville"
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12} sm={5}>
                <TextField
                  InputLabelProps={{
                    shrink: true,
                    required: true,
                  }}
                  fullWidth
                  value={presta['invoice_siret']}
                  error={
                    errors.find((item) => item.source == 'invoice_siret')?.error
                  }
                  onChange={(e) => {
                    handleChange(e, 'invoice_siret')
                  }}
                  label="SIRET"
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12} sm={5}>
                <TextField
                  InputLabelProps={{
                    shrink: true,
                    required: true,
                  }}
                  fullWidth
                  value={presta['invoice_tva']}
                  error={
                    errors.find((item) => item.source == 'invoice_tva')?.error
                  }
                  onChange={(e) => {
                    handleChange(e, 'invoice_tva')
                  }}
                  label="TVA"
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12} sm={5}>
                <TextField
                  InputLabelProps={{
                    shrink: true,
                    required: true,
                  }}
                  fullWidth
                  value={presta['invoice_iban']}
                  error={
                    errors.find((item) => item.source == 'invoice_iban')?.error
                  }
                  onChange={(e) => {
                    handleChange(e, 'invoice_iban')
                  }}
                  label="IBAN"
                  helperText={false}
                />
              </Grid>
            </Grid>
            <Box sx={{ marginTop: 30, textAlign: 'right' }}>
              <Button
                variant="outlined"
                label="Enregistrer"
                color="primary"
                className={classes.button}
                disabled={loading}
                onClick={(e) => {
                  e.preventDefault()
                  onSubmit()
                }}
              />
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  )
}

const PrestaParagraph = () => {
  return (
    <div style={{ width: '100%' }}>
      <Typography
        variant="h5"
        style={{
          color: darkGrey,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
        gutterBottom={'true'}
      >
        <p style={{ margin: 0 }}>Informations de facturation</p>
      </Typography>
      <Typography variant="subtitle2" style={{ color: darkGrey }}>
        Veuillez vous assurer de l'exactitude des informations et cliquer sur
        "Enregistrer" avant de continuer.
      </Typography>
      <br />
    </div>
  )
}
export default PrestaInformationsEditForm
